import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Avatar, Badge } from 'legion-ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`An avatar is a graphical representation of an object or entity, such as a person or organization.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Avatar } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion have variant `}<inlineCode parentName="p">{`Basic`}</inlineCode>{` and `}<inlineCode parentName="p">{`Additional badge`}</inlineCode></p>
    <h3><strong parentName="h3">{`Basic`}</strong></h3>
    <p>{`Default usage of Avatar and its behavior being `}<inlineCode parentName="p">{`lg`}</inlineCode>{` in size, and accepts `}<inlineCode parentName="p">{`src`}</inlineCode>{` prop to serve the image.`}</p>
    <div className="wrapper-display-component-three">
  <div className="item-three">
    <Avatar src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" mdxType="Avatar" />
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Avatar />
`}</code></pre>
    <h3><strong parentName="h3">{`Additional badge`}</strong></h3>
    <p>{`You can provide an additional badge.`}</p>
    <div className="wrapper-display-component-three">
  <div className="item-three inherit">
    <Avatar size="lg" src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" mdxType="Avatar" />
    <Badge size="lg" variant="online" bordered mt={-3} mdxType="Badge" />
  </div>
  <div className="item-three inherit">
    <Avatar size="md" src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" mt={2} mdxType="Avatar" />
    <Badge size="lg" variant="online" bordered mt={-3} mdxType="Badge" />
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<div class="ruby">
  <div class="inherit mr-8">
    <Avatar size="lg" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
    <Badge size="lg" variant="online" bordered mt={-3} />
  </div>
  <div class="inherit">
    <Avatar size="md" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
    <Badge size="lg" variant="online" bordered mt={-3} />
  </div>
</div>
`}</code></pre>
    <br />
    <h2>{`Attribute`}</h2>
    <h3><strong parentName="h3">{`Size`}</strong></h3>
    <p>{`You can customise the size of the Avatar via the size prop, which accepts either `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, or `}<inlineCode parentName="p">{`large`}</inlineCode>{`. By default size is `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <div className="wrapper-display-component-three">
  <div className="item-three">
    <Avatar size="lg" src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" mdxType="Avatar" />
  </div>
  <div className="item-three">
    <Avatar size="md" src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" mdxType="Avatar" />
  </div>
  <div className="item-three">
    <Avatar size="sm" src="https://xsgames.co/randomusers/assets/avatars/male/76.jpg" mdxType="Avatar" />
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Avatar size="lg" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
<Avatar size="md" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
<Avatar size="sm" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sm`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`md`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`lg`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`lg`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Set the size of the avatar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`style`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The `}<inlineCode parentName="td">{`style`}</inlineCode>{` prop lets you style elements inline`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      